import * as React from 'react';
import * as DTOS from "../../../FeralScan.dtos";
import * as ReactDatetimeClass from "react-datetime";
import { connect } from 'react-redux';
import PlotEventList from './PlotEventList';
import * as DataActionCreators from "../../../actions/data.actions";
import * as MapActionCreators from "../../../actions/map.actions";
import * as AdminActionCreators from "../../../actions/admin.actions";
import moment = require('moment');
import { IAppState } from '../../../app';
import { bindActionCreators } from 'redux';
import { searchUsers } from '../../../epics/admin.epic';

interface IPlotEventAdminSearchProps {
    dateTimeFormat: string;
    maxPlotEvents: number;
    onStartDateChange: any;
    onEndDateChange: any;
    plotEvents: DTOS.PlotEvent[];
    plotEventsLoading: boolean;
    searchStartDate: any;
    searchEndDate: any;
    totalPlotEventCount: number;
    users: DTOS.User[];
}

interface IPlotEventAdminSearchActions {
    deletePlotEvent: typeof MapActionCreators.deleteEventRequest;
    getPlotEvents: typeof DataActionCreators.getPlotEventsRequest;
    searchUsers: typeof AdminActionCreators.searchUsersRequest;
}

type PlotEventAdminSearchItemProps = IPlotEventAdminSearchProps & IPlotEventAdminSearchActions;

class PlotEventAdminSearch extends React.PureComponent<PlotEventAdminSearchItemProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.searchUsers(null, false);
    }

    render() {
        const { dateTimeFormat, plotEvents, plotEventsLoading, maxPlotEvents, totalPlotEventCount } = this.props;

        const dateFilter = <div className="row">
            <ReactDatetimeClass
                className={"filter-date-calendar col-5"}
                onChange={this.props.onStartDateChange}
                dateFormat={"DD/MM/YYYY"}
                timeFormat={false}
                inputProps={{
                    placeholder: "DD/MM/YYYY",
                    className: "form-control form-control-date",
                }}
                input={true}
                value={...this.props.searchStartDate}
            />
            <span className="px-0 col text-center">to</span>
            <ReactDatetimeClass
                className={"filter-date-calendar col-5"}
                onChange={this.props.onEndDateChange}
                dateFormat={"DD/MM/YYYY"}
                timeFormat={false}
                inputProps={{
                    placeholder: "DD/MM/YYYY",
                    className: "form-control form-control-date",

                }}
                input={true}
                value={...this.props.searchEndDate}
            />
        </div>;

        var plotEventsWithSurnames = [];
        if(this.props.users) {
            plotEvents.map(pe => {
                var user = this.props.users.find(u => {
                    return u.id == pe.userId
                });
                plotEventsWithSurnames.push({
                    ...pe,
                    surname: user.surname
                });
            });
        }

        return (<>
            <div className="col-12">
                <div>
                    Scans returned: {plotEvents ? plotEvents.length : 0}
                    {plotEvents.length === maxPlotEvents ? ` (Some scans may have been omitted due to limit of ${maxPlotEvents} in one search.)` : ''}
                </div>
                <div>Scans total: {totalPlotEventCount !== undefined ? totalPlotEventCount : 'Unknown'}</div>
            </div>
            <div className="col-12">
                {dateFilter}
            </div>
            {plotEvents.length >= maxPlotEvents ?
                <div className="col"><p className="alert alert-warning p-0">
                    <i className="fa fa-warning p-3" />{`Some scans may have been omitted due to a limit of ${maxPlotEvents} in one search.`}</p>
                </div>
                : null
            }
            <PlotEventList
                className="col-12 mt-2"
                dateTimeFormat={dateTimeFormat}
                hidePaginationControls={false}
                hideSortControls={false}
                onDeletePlotEvent={this.props.deletePlotEvent}
                plotEvents={plotEventsWithSurnames}
                plotEventsLoading={plotEventsLoading}
                showUser={true}
            />
        </>
        );
    }
}

const mapStateToProps = (state: IAppState) => {

    return {
        users: state.admin.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        deletePlotEvent: MapActionCreators.deleteEventRequest,
        searchUsers: AdminActionCreators.searchUsersRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PlotEventAdminSearch);